import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const Body = (props) => (

    <div>
        {
            !props.instoreOnlineSales || props.instoreOnlineSales.length == 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {props.beginDate ?
                                <p><i>From</i> <b>{moment(props.beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {props.endDate ? <b>{moment(props.endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <br />
                    <div className="table-responsive">
                        {
                            props.instoreOnlineSales.map(item => {
                                return (

                                    <div className="row m-0 mb-2  text-center" key={item.name} >
                                        <div className="row m-0 mb-2">
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <label>Product Name</label>
                                                <h3 className="m-0 grey-text">{item.name}</h3>
                                                <label>SKU</label>
                                                <h3 className="m-0 grey-text">{item.sku}</h3>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center">
                                                <label>Category</label>
                                                <h3 className="m-0 grey-text">{item.category}</h3>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center">
                                                <label>In-Store Sales</label>
                                                <h3 className="danger m-0">{getDollarFormat(item.instore)}</h3>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center">
                                                <label>Online Sales</label>
                                                <h3 className="danger m-0">{getDollarFormat(item.online)}</h3>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center">
                                                <label>Total Sales</label>
                                                <h3 className="money m-0">{getDollarFormat(item.online + item.instore)}</h3>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                </div>
        }
    </div>
);

export default Body;